import { api } from "@api/api";
import { Code } from "@modules/codes/types";
import { CodeFormValues } from "@modules/codes/validations";

export async function createCodeService(data: CodeFormValues): Promise<Code> {
  const { data: code } = await api.post<Code>("v1/limited_code_admin/", data);

  return code;
}
